import { combineReducers } from '@reduxjs/toolkit';
import { authSlice } from './authSlice';
import { adminSlice } from './adminSlice';
import { loadingSlice } from './loadingSlice';
import { lookupSlice } from './lookupSlice';
import { livelihoodSlice } from './livelihoodSlice';
import { ccSlice } from './ccSlice';
import { researchSlice } from './researchSlice';

const reducers = combineReducers({
  auth: authSlice.reducer,
  admin: adminSlice.reducer,
  loading: loadingSlice.reducer,
  lookup: lookupSlice.reducer,
  livelihood: livelihoodSlice.reducer,
  ccData: ccSlice.reducer,
  researchData: researchSlice.reducer,
});

export default reducers;
